<template>
  <div class="col-md-12 pl-0 pr-0">
    <!-- <div class="col-md-12 yuanjiao pt-3 pb-3 pl-0 pr-0 sjbzt"
			style="font-size: calc(7px + 0.4vw);line-height: calc(15px + 0.5vw);">
			<div class="col-md-12 d-flex pl-0 pr-0">
				<div @click="fun(1)" class="pt-3 pb-3 curpo qieh sjbzt"
					:style="{'background':show==1?'#FFFFFF':'#FFFAF0','font-weight':show==1?'700':'500','color':show==1?'':'#999999'}">
					{{$t('活动中数据')}}</div>
				<div @click="fun(2)" class="pt-3 pb-3 curpo qieh sjbzt"
					:style="{'background':show==2?'#FFFFFF':'#FFFAF0','font-weight':show==2?'700':'500','color':show==2?'':'#999999'}">
					{{$t('活动后数据')}}</div>
			</div>
			<hdzsj ref="hdzsj" v-if="show==1"></hdzsj>
			<hdhsj ref="hdhsj" v-if="show==2"></hdhsj>
		</div> -->

    <!-- 新样式 -->
    <!-- 活動投入 -->
    <div class="yuanjiao baise p-3 mt-3">
      <div class="pb-2" style="font-size: 20px;font-weight: 600;    border-bottom: 2px solid #FFD672;">{{$t("活動投入")}}</div>
      <!-- 資金投入分析 -->
      <div class="mt-3 card">
        <div class="card-header" style="font-weight: 600;">{{$t("資金投入分析")}}</div>
        <div class="col-sm-12   align-items-center" :class="screenWidth<=1200?'':'d-flex'">
          <div class=" d-flex justify-content-center align-items-center" :class="screenWidth<=1200?'col-sm-12':'col-sm-6'">
            <div id="chartcontainers" :class="screenWidth<=1200?'echarts-css-small':'echarts-css-big'" style="" ></div>
          </div>
          <div class=" d-flex justify-content-center align-items-center" :class="screenWidth<=1200?'col-sm-12':'col-sm-6'">
            <table class="data-table">
              <thead>
                  <tr>
                      <th>{{$t("项目")}}</th>
                      <th>{{$t("金额")}} (NT$)</th>
                      <th>{{$t("佔比")}}</th>
                  </tr>
              </thead>
              <tbody>
                <tr>
                    <td>{{$t("行政費用")}}</td>
                    <td>{{numd()}}</td>
                    <td>{{(numd()/(numd()+nume()+numg()+numq()+numw())*100).toFixed(2) || 0}}%</td>
                </tr>
                <tr>
                    <td>{{$t("業務費用")}}</td>
                    <td>{{nume()}}</td>
                    <td>{{(nume()/(numd()+nume()+numg()+numq()+numw())*100).toFixed(2) || 0}}%</td>
                </tr>
                <tr>
                    <td>{{$t("設備費用")}}</td>
                    <td>{{numg()}}</td>
                    <td>{{(numg()/(numd()+nume()+numg()+numq()+numw())*100).toFixed(2) || 0}}%</td>
                </tr>
                <tr>
                    <td>{{$t("營運費用")}}</td>
                    <td>{{numq()}}</td>
                    <td>{{(numq()/(numd()+nume()+numg()+numq()+numw())*100).toFixed(2) || 0}}%</td>
                </tr>
                <tr>
                    <td>{{$t("其他費用")}}</td>
                    <td>{{numw()}}</td>
                    <td>{{(numw()/(numd()+nume()+numg()+numq()+numw())*100).toFixed(2) || 0}}%</td>
                </tr>
            </tbody>
            </table>
          </div>
        </div>
      </div>
      <!-- 人力投入分析 -->
      <div class="mt-3 card">
        <div class="card-header" style="font-weight: 600;">人力投入分析</div>
        <div class="col-sm-12   align-items-center" :class="screenWidth<=1200?'':'d-flex'">
          <div class=" d-flex justify-content-center align-items-center" :class="screenWidth<=1200?'col-sm-12':'col-sm-6'">
            <div id="chartcontainers1" :class="screenWidth<=1200?'echarts-css-small':'echarts-css-big'" style=""></div>
          </div>
          <div class="d-flex justify-content-center align-items-center" :class="screenWidth<=1200?'col-sm-12':'col-sm-6'">
            <div id="chartcontainers2" :class="screenWidth<=1200?'echarts-css-small':'echarts-css-big'" style=""></div>
          </div>
        </div>
        <div class="mt-2 pl-3 pr-3">
          <div class="pb-2" style="font-size: 18px;font-weight: 600;border-bottom: 2px solid #FFF6E0;">志工參與情況</div>
          <div class="mt-2">
            <table class="data-table">
              <thead>
                  <tr>
                      <th>日期</th>
                      <th>志工人數</th>
                      <th>志工服務時數</th>
                      <!-- <th>一般參與者</th> -->
                  </tr>
              </thead>
              <tbody>
                  <tr v-for="item,index in input.human" :key="index">
                      <td>{{item.service_date || '--'}}</td>
                      <td>{{item.num || 0}}</td>
                      <td>{{item.hour || 0}}</td>
                      <!-- <td>320</td> -->
                  </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!-- 物資投入分析 -->
      <div class="mt-3 card">
        <div class="card-header" style="font-weight: 600;">物資投入分析</div>
        <div class="col-sm-12">
          <div id="chartcontainers3" style="height: 400px;"></div>
        </div>
        <div class="pl-3 pr-3 mb-3">
          <div class="p-3 yuanjiao" style="background-color:#FFF6E0;">
            <div style="font-size: 14px;font-weight: 600;">物資投入總結</div>
            <div style="font-size: 14px;" class="mt-2">{{ text1 }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 活動產出 -->
    <div class="yuanjiao baise p-3 mt-3 mb-3">
      <div class="pb-2" style="font-size: 20px;font-weight: 600;    border-bottom: 2px solid #FFD672;">{{$t("活動產出")}}</div>
      <!-- 社會影響 -->
      <div class="mt-3 card" v-for="item,index in out_put.quantitative_list" :key="index">
        <div class="card-header" style="font-weight: 600;">{{item.description}}</div>
        <div class="col-sm-12 mb-3">
          <div >
            <div class="mt-3 d-flex justify-content-between align-items-center">
              <div class="" style="font-size: 16px;font-weight: 500;"></div>
              <div class="" style="font-size: 16px;font-weight: 500;"> <span style="color:#F0B94D ;">{{item.results}} {{ item.goals_arr[1] }}  </span>  ({{$t("目標")}}: {{item.goals}})</div>
            </div>
            <b-progress :value="Number(item.results)/Number(item.goals_arr[0])*100" max="100" height="8px" class="mt-2 yuanjiao progress-div"></b-progress>
          </div>
        </div>
        <div class="pl-3 pr-3 mb-3">
          <div class="p-3 yuanjiao" style="background-color:#FFF6E0;">
            <div style="font-size: 14px;font-weight: 600;">{{item.description}}{{$t("總結")}}</div>
            <div style="font-size: 14px;" class="mt-2">{{ item.results_description }}</div>
          </div>
        </div>
      </div>
      
    </div>

    <!-- 旧版样式 -->
    <div class="yuanjiao baise p-3 mt-3 mb-3" v-if="false">
      <div class="sjbzt" style="font-weight: 600;font-size: calc(10px + 0.4vw);">{{ $t("資源投入分析") }}</div>
      <div class="mt-3 mb-4" v-if="input.human.length>0">
        <div class="d-flex justify-content-between align-items-center mt-3 mb-2 sjbxzt" style="font-size: calc(9px + 0.4vw);">
          <div>{{ $t("人力投入") }}</div>
          <div style="color: #666666;">{{ $t("參與志工") }}</div>
        </div>
        <div class="d-flex align-items-center pt-2 pb-2 text-center sjbxzt" style="background: #FFFAF0;font-size: calc(9px + 0.4vw);">
          <div style="width: 25%;">{{ $t("志工人數") }}</div>
          <div style="width: 25%;">{{ $t("總服務時數") }}</div>
          <div style="width: 25%;">{{ $t("總積分") }}</div>
          <div style="width: 25%;">{{ $t("時薪") }}</div>
        </div>
        <div v-for="(item,index) in input.human" :key="index" class="d-flex align-items-center pt-2 pb-2 text-center sjbxzt" :style="{'background':index % 2 == 0 ? '#FDFDFC' : '#F6F4F0'}" style="font-size: calc(9px + 0.4vw);">
          <div style="width: 25%;">{{ item.num }}</div>
          <div style="width: 25%;">{{ item.hour }}</div>
          <div style="width: 25%;">{{ (item.price * item.hour).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</div>
          <div style="width: 25%;">{{ item.price }}</div>
        </div>
        <div class="mt-2 sjbxzt" style="font-size: calc(9px + 0.4vw);">{{ $t("總好人積分：") }}{{ (totalgroup()).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</div>
      </div>
      <div class="mb-4" v-if="input.material.length>0">
        <div class="d-flex justify-content-between align-items-center mt-3 mb-2 sjbxzt" style="font-size: calc(9px + 0.4vw);">
          <div>{{ $t("物力投入") }}</div>
          <div style="color: #666666;">{{ $t("捐贈物資") }}</div>
        </div>
        <div class="d-flex align-items-center pt-2 pb-2 text-center sjbxzt" style="background: #FFFAF0;font-size: calc(9px + 0.4vw);">
          <div style="width: 20%;">{{ $t("名稱") }}</div>
          <div style="width: 20%;">{{ $t("計量單位") }}</div>
          <div style="width: 20%;">{{ $t("收到數量") }}</div>
          <div style="width: 20%;">{{ $t("總金額") }}</div>
          <div style="width: 20%;">{{ $t("企業或團體") }}</div>
        </div>
        <div v-for="(item,index) in input.material" :key="index" class="d-flex align-items-center pt-2 pb-2 text-center sjbxzt" :style="{'background':index % 2 == 0 ? '#FDFDFC' : '#F6F4F0'}" style="font-size: calc(9px + 0.4vw);">
          <div style="width: 20%;">{{ item.name }}</div>
          <div style="width: 20%;">{{ item.unit }}</div>
          <div style="width: 20%;">{{ item.num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</div>
          <div style="width: 20%;">{{ (item.amount + ' NT$').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</div>
          <div style="width: 20%;">{{ item.enterprise }}</div>
        </div>
        <div class="mt-2 sjbxzt" style="font-size: calc(9px + 0.4vw);">{{ $t("捐贈物資總額：") }}{{ (totalsupplies() + ' NT$').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</div>
      </div>
      <div class="mb-4 sjbxzt" v-if="input.budget.length>0" style="font-size: calc(9px + 0.4vw);">
        <div class="d-flex justify-content-between align-items-center mt-3 mb-2">
          <div>{{ $t("金錢投入") }}</div>
        </div>
        <div v-for="(item,index) in input.budget" :key="index" class="pt-3 pb-3 yuanjiao text-center" style="background: #FFFAF0;">
          <div class="mb-2">{{ $t("活动預算") }}</div>
          <div>{{ (item.amount + ' NT$').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</div>
        </div>
      </div>
      <div class="mb-4 sjbxzt" style="font-size: calc(9px + 0.4vw);">
        <div class="d-flex justify-content-between align-items-center mt-3 mb-2">
          <div>{{ $t("組織金錢投入") }}</div>
          <div style="color: #666666;">{{ $t("收入項") }}</div>
        </div>
        <div class="d-flex align-items-center justify-content-between mb-3 text-center">
          <div class="yuanjiao pt-3 pb-3" style="background: #FFFAF0;width: 49%;">{{ $t("內部資金") }} {{ (input.internal_funds + ' NT$').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</div>
          <div class="yuanjiao pt-3 pb-3" style="background: #FFFAF0;width: 49%;">{{ $t("專案補助") }} {{ (input.project_assistance + ' NT$').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</div>
        </div>
        <div class="d-flex align-items-center pt-2 pb-2 text-center sjbxzt" style="background: #FFFAF0;font-size: calc(9px + 0.4vw);">
          <div style="width: 25%;">{{ $t("捐款記錄") }}</div>
          <div style="width: 25%;">{{ $t("個人捐款") }}</div>
          <div style="width: 25%;">{{ $t("企業捐款") }}</div>
          <div style="width: 25%;">{{ $t("總額") }}</div>
        </div>
        <div v-for="(item,index) in input.customized_donation" :key="index" class="d-flex align-items-center pt-2 pb-2 text-center sjbxzt" :style="{'background':index % 2 == 0 ? '#FDFDFC' : '#F6F4F0'}" style="font-size: calc(9px + 0.4vw);">
          <div style="width: 25%;">{{ item.name }}</div>
          <div style="width: 25%;">{{ item.personal_amount }}</div>
          <div style="width: 25%;">{{ item.enterprise_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</div>
          <div style="width: 25%;">{{ (item.received_amount + ' NT$').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</div>
        </div>
        <div class="mt-2 sjbxzt" style="font-size: calc(9px + 0.4vw);">{{ $t("捐款總額：") }}{{ (input.internal_funds + input.project_assistance + ' NT$').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</div>
      </div>
      <div class="mb-4 sjbxzt" style="font-size: calc(9px + 0.4vw);">
        <div class="pt-3 pb-3 yuanjiao text-center" style="background: #FFFAF0;">
          <div>{{ $t("組織投入金錢總額") }} {{ (totalorganize() + ' NT$').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</div>
        </div>
      </div>
      <div>
        <div class="d-flex align-items-center none">
          <div id="chartcontainers" style="height: 400px;width: calc(26rem + 0.4vw);"></div>
          <div style="width: 30%;">
            <div style="font-size: calc(9px + 0.4vw);font-weight: 500;">{{ $t("經費使用說明")}}</div>
            <div>
              <span>{{ input.illustrate }}</span>
            </div>
          </div>
        </div>
		<div class="show mb-3">
          <div id="chartcontainer" style="height: 300px;width: calc(20rem + 0.4vw);"></div>
          <div style="width: 100%;">
            <div class="sjbzt" style="font-size: calc(9px + 0.4vw);">{{ $t("經費使用說明")}}</div>
            <div>
              <span class="sjbxzt">{{ input.illustrate }}</span>
            </div>
          </div>
        </div>
        <div class="mb-4 sjbxzt" style="font-size: calc(9px + 0.4vw);">
          <div class="pt-3 pb-3 yuanjiao text-center" style="background: #FCD7D5;">
            <div>{{ $t("費用支出總額") }} {{ ((totalorganize() + numg() + numq() + numw()) + ' NT$').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</div>
          </div>
        </div>
        <div class="sjbxzt" style="font-size: calc(9px + 0.4vw);">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <div class="sjbzt" style="font-size: calc(10px + 0.4vw);font-weight: 600;">{{ $t("活動量化產出") }}</div>
          </div>
		  <div class="d-flex justify-content-between align-items-center mb-3">
            <div>{{ $t("好事道平台產出") }}</div>
          </div>
		  <div class="d-flex align-items-center justify-content-between mb-2">
              <div class="yuanjiao p-3 d-flex align-items-center justify-content-between" style="background: #F6F4F0;width: 49%;">
				<div>{{ $t("參與人數") }}</div>
				<div>{{ out_put.member_num }}</div>
			  </div>
			  <div class="yuanjiao p-3 d-flex align-items-center justify-content-between" style="background: #F6F4F0;width: 49%;">
				<div>{{ $t("志工人數") }}</div>
				<div>{{ out_put.num }}</div>
			  </div>
		  </div>
		  <div class="d-flex align-items-center justify-content-between">
              <div class="yuanjiao p-3 d-flex align-items-center justify-content-between sjbxzt" style="background: #F6F4F0;width: 49%;font-size: calc(9px + 0.4vw);">
				<div class="d-flex align-items-center">
					<div class="mr-2"><img style="width: calc(20px + 0.4vw);" src="@/img/daohangl/pic_hssy_haorenbi@2x.png" alt=""></div>
					<div>{{ $t("發行好人積分") }}</div>
				</div>
				<div>{{ out_put.good_coin }}</div>
			  </div>
			  <div class="yuanjiao p-3 d-flex align-items-center justify-content-between sjbxzt" style="background: #F6F4F0;width: 49%;font-size: calc(9px + 0.4vw);">
				<div class="d-flex align-items-center">
					<div class="mr-2"><img style="width: calc(20px + 0.4vw);" src="@/img/daohangl/pic_hssy_tanbi@2x.png" alt=""></div>
					<div>{{ $t("發行碳積分") }}</div>
				</div>
				<div>{{ out_put.carbon_coin }}</div>
			  </div>
		  </div>
		  <div class="d-flex justify-content-between align-items-center mb-3 mt-3">
            <div>{{ $t("企業/團體產出") }}</div>
          </div>
		  <div class="d-flex align-items-center justify-content-stretch none" style="gap: 1rem;">
              <div class="yuanjiao p-3" style="width: 32.5%;background: #F6F4F0;">
                  <div class="mb-2">{{ $t("環境效益") }}</div>
				  <div class="yuanjiao pl-3 pr-3 pt-2 pb-2 d-flex align-items-center justify-content-between" v-for="(item,index) in out_put.quantitative_environmental" :key="index" style="background: #EAE6DE;">
                     <div>{{ item.results }}</div>
					 <div>{{ item.description }}</div>
				  </div>
			  </div>
			  <div class="yuanjiao p-3" style="width: 32.5%;background: #F6F4F0;">
                  <div class="mb-2">{{ $t("社會效益") }}</div>
				  <div class="yuanjiao pl-3 pr-3 pt-2 pb-2 d-flex align-items-center justify-content-between" v-for="(item,index) in out_put.quantitative_social" :key="index" style="background: #EAE6DE;">
                     <div>{{ item.results }}</div>
					 <div>{{ item.description }}</div>
				  </div>
			  </div>
			  <div class="yuanjiao p-3" style="width: 32.5%;background: #F6F4F0;">
                  <div class="mb-2">{{ $t("經濟效益") }}</div>
				  <div class="yuanjiao pl-3 pr-3 pt-2 pb-2 d-flex align-items-center justify-content-between" v-for="(item,index) in out_put.quantitative_economic" :key="index" style="background: #EAE6DE;">
                     <div>{{ item.results }}</div>
					 <div>{{ item.description }}</div>
				  </div>
			  </div>
		  </div>
		  <div class="show">
              <div class="yuanjiao p-3 mb-3" style="background: #F6F4F0;">
                  <div class="mb-2">{{ $t("環境效益") }}</div>
				  <div class="yuanjiao pl-3 pr-3 pt-2 pb-2 d-flex align-items-center justify-content-between" v-for="(item,index) in out_put.quantitative_environmental" :key="index" style="background: #EAE6DE;">
                     <div>{{ item.results }}</div>
					 <div>{{ item.description }}</div>
				  </div>
			  </div>
			  <div class="yuanjiao p-3 mb-3" style="background: #F6F4F0;">
                  <div class="mb-2">{{ $t("社會效益") }}</div>
				  <div class="yuanjiao pl-3 pr-3 pt-2 pb-2 d-flex align-items-center justify-content-between" v-for="(item,index) in out_put.quantitative_social" :key="index" style="background: #EAE6DE;">
                     <div>{{ item.results }}</div>
					 <div>{{ item.description }}</div>
				  </div>
			  </div>
			  <div class="yuanjiao p-3" style="background: #F6F4F0;">
                  <div class="mb-2">{{ $t("經濟效益") }}</div>
				  <div class="yuanjiao pl-3 pr-3 pt-2 pb-2 d-flex align-items-center justify-content-between" v-for="(item,index) in out_put.quantitative_economic" :key="index" style="background: #EAE6DE;">
                     <div>{{ item.results }}</div>
					 <div>{{ item.description }}</div>
				  </div>
			  </div>
		  </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { activity_data_new } from "@/request/hshd/index.js";
import * as echarts from "echarts";
// import hdzsj from "./hdsj/hdzsj.vue";
// import hdhsj from "./hdsj/hdhsj.vue";
export default {
  // components: {
  // 	hdzsj,
  // 	hdhsj,
  // },
  data() {
    return {
      show: 1,
      isLoading: false,
      name: "",
      input: {},
      out_put: {},
      screenWidth:0,
      text1:"",
    };
  },
  created() {
    this.updateScreenWidth(); // 初始化宽度
    window.addEventListener("resize", this.updateScreenWidth);
  },
  mounted() {
    this.info();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateScreenWidth);
  },
  computed: {},
  methods: {
    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
    },
    totalorganize() {
      // 計算行政費用和業務費用總和
      return this.numd() + this.input.business_expense.reduce((sum, item) => {
        return sum + Number(item.amount || 0);
      }, 0);
    },
    totalIncome() {
      // 計算收入總和
      return Number(this.input.internal_funds || 0) + 
             Number(this.input.project_assistance || 0) + 
             this.input.budget.reduce((sum, item) => {
               return sum + Number(item.amount || 0);
             }, 0);
    },
    totalsupplies() {
      let a = "";
      for (let index = 0; index < this.input.material.length; index++) {
        a = a + this.input.material[index].amount;
      }
      return a;
    },
    totalgroup() {
      let a = "";
      for (let index = 0; index < this.input.human.length; index++) {
        a = a + this.input.human[index].price * this.input.human[index].hour;
      }
      return a;
    },
    async info() {
      const { data, code } = await activity_data_new({
        id: this.$route.params.id,
      });
      if (code == 200) {
        this.input = data.input;
        this.out_put = data.out_put;
        setTimeout(() => {
          // 資金投入分析
          this.getBar(
            this.numd(),
            this.nume(),
            this.numg(),
            this.numq(),
            this.numw()
          );
          // 人力投入分析餅圖
          this.getBar1();
          // 人力投入折柱混合
          this.getBar2();
          // 物資投入分析
          this.getBar3();
        }, 10);
      }
    },
    // 资金投入表
    getBar(a, b, c, d, e) {
      console.log(a, b, c, d, e, document.getElementById("chartcontainers"));
      var chartDom = document.getElementById("chartcontainers");
      let myChart = echarts.init(chartDom);
      var option = {
        title: {
          text: `資金投入分布(總額:NT$ ${a+b+c+d+e})`,
          left: 'center',
          top:'20'
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          type: 'scroll',
          bottom: 20,
          left: 'center'
        },
        series: [
          {
            type: "pie",
            radius: ["40%", "60%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderColor: "#fff",
              borderWidth: 2,
            },
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 25,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            center: ["50%", "50%"],
            data: [
              {
                value: a,
                name:
                  "行政費用：" +
                  (a > 0 ? (a / (a + b + c + d + e)) * 100 : 0).toFixed(2) +
                  "%",
                itemStyle: {
                  color: "#ffd672",
                },
              },
              {
                value: b,
                name: 
                  "業務費用：" + 
                  (b > 0 ? (b / (a + b + c + d + e)) * 100 : 0).toFixed(2) + 
                  "%",
                itemStyle: { 
                  color: "#91cc75" }
              },  
              {
                value: c,
                name:
                  "設備費用：" +
                  (c > 0 ? (c / (a + b + c + d + e)) * 100 : 0).toFixed(2) +
                  "%",
                itemStyle: {
                  color: "#fab1ab",
                },
              },
              {
                value: d,
                name:
                  "營運費用：" +
                  (d > 0 ? (d / (a + b + c + d + e)) * 100 : 0).toFixed(2) +
                  "%",
                itemStyle: {
                  color: "#fdbc94",
                },
              },
              {
                value: e,
                name:
                  "其他費用：" +
                  (e > 0 ? (e / (a + b + c + d + e)) * 100 : 0).toFixed(2) +
                  "%",
                itemStyle: {
                  color: "#a6d1ff",
                },
              },
            ],
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    // 人力投入分析饼图
    getBar1() {
      console.log(document.getElementById("chartcontainers1"));
      var chartDom = document.getElementById("chartcontainers1");
      let myChart = echarts.init(chartDom);
      var option = {
        title: {
          text: `志工類型分佈`,
          left: 'center',
          top:'50'
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          bottom: "50",
        },
        series: [
          {
            type: "pie",
            radius: ["50%"],
            itemStyle: {
              borderColor: "#fff",
              borderWidth: 2,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            data: [
              { value: this.input.human_enterprise, name: '企業員工',itemStyle: {color: "#ffd672",}, },
              { value: this.input.human_general, name: '一般大眾',itemStyle: {color: "#fab1ab",} },
            ],
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    // 人力投入折柱混合
    getBar2() {
      let arr = this.input.human;
      let Xarr = []; // X轴标记
      let pArr = []; // 志工人数
      let sArr = []; // 志工服务时数
      let max1 = 0;
      let max2 = 0;
      for(let i=0; i<arr.length; i++){
        Xarr.push(arr[i].service_date);
        pArr.push(arr[i].num);
        sArr.push(arr[i].hour);
        max1 += arr[i].num;
        max2 += arr[i].hour;
      }

      var chartDom = document.getElementById("chartcontainers2");
      let myChart = echarts.init(chartDom);
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          data: ['志工人數', '志工服務時數'],
          top:'20'
        },
        grid: {
            left: '15%',   // 增加边距，让图表缩小
            right: '15%',
        },
        xAxis: [
          {
            type: 'category',
            data: Xarr,
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            min: 0,
            max: max1,
            axisLabel: {
              formatter: '{value}'
            }
          },
          {
            type: 'value',
            min: 0,
            max: max2,
            axisLabel: {
              formatter: '{value}'
            }
          }
        ],
        series: [
          {
            name: '志工人數',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: pArr,
            itemStyle: {color: "#ffd672",},
          },
          {
            name: '志工服務時數',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: sArr,
            itemStyle: {color: "#fab1ab",},
          }
        ]
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    // 物資投入分析
    getBar3() {
      let arr = this.input.material;
      let Xarr = []; // X轴标记
      let newArr = [];
      let colorArr = ['#ffd672','#fab1ab','#fdbc94','#a5d1ff','#e7a5ff'];
      let max = 0;
      for(let i=0; i<arr.length; i++){
        Xarr.push(arr[i].name);
        newArr.push({
          value: arr[i].amount,
          itemStyle: {
            color: colorArr[i%colorArr.length]
          }
        });
        max += arr[i].amount;
      }
      this.text1 = `本次活動共投入${newArr.length}項物資，總價值NT$ ${max}。主要物資包括${Xarr.join("、")}等。活動器材主要用於各個互動攤位和展示區域，確保活動順利進行。`;

      var chartDom = document.getElementById("chartcontainers3");
      let myChart = echarts.init(chartDom);
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        grid: {
            bottom: '10%',  // 内邊距
        },
        title: {
          text: `物資投入分析(總價值:NT$ ${max})`,
          left: 'center',
          top:'20'
        },
        xAxis: {
          type: 'category',
          data: Xarr
        },
        yAxis: {
            type: 'value',
            min: 0,
            max: max,
            axisLabel: {
              formatter: '{value}'
            }
        },
        series: [
          {
            data: newArr,
            type: 'bar',
            center: ['30%', '100%'], // 向左移动
          }
        ]
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    // 圓餅圖-旧版样式
    getBars(a, b, c, d, e) {
      console.log(a, b, c, d, e, document.getElementById("chartcontainer"));
      var chartDom = document.getElementById("chartcontainer");
      let myChart = echarts.init(chartDom);
      var option = {
        tooltip: {
          trigger: "item",
        },
        legend: {
          top: "5%",
          left: "center",
        },
        series: [
          {
            name: this.$t("成果統計"),
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2,
            },
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 25,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            center: ["50%", "60%"],
            data: [
              {
                value: a,
                name:
                  "行政費用：" +
                  (a > 0 ? (a / (a + b + c + d + e)) * 100 : 0).toFixed(2) +
                  "%",
                itemStyle: {
                  color: "#ffd672",
                },
              },
              {
                value: b,
                name: 
                  "業務費用：" + 
                  (b > 0 ? (b / (a + b + c + d + e)) * 100 : 0).toFixed(2) + 
                  "%",
                itemStyle: { 
                  color: "#91cc75" }
              },  
              {
                value: c,
                name:
                  "設備費用：" +
                  (c > 0 ? (c / (a + b + c + d + e)) * 100 : 0).toFixed(2) +
                  "%",
                itemStyle: {
                  color: "#fab1ab",
                },
              },
              {
                value: d,
                name:
                  "營運費用：" +
                  (d > 0 ? (d / (a + b + c + d + e)) * 100 : 0).toFixed(2) +
                  "%",
                itemStyle: {
                  color: "#fdbc94",
                },
              },
              {
                value: e,
                name:
                  "其他費用：" +
                  (e > 0 ? (e / (a + b + c + d + e)) * 100 : 0).toFixed(2) +
                  "%",
                itemStyle: {
                  color: "#a6d1ff",
                },
              },
            ],
          }
        ]
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    numd() {
      return this.input.staff.reduce((sum, item) => {
        const price = Number(item.num) * Number(item.hour) * Number(item.price) || 0;
        return sum + price;
      }, 0);
    },
    nume() {
      return this.input.business_expense.reduce((sum, item) => {
        const price = parseFloat(item.amount) || 0;
        return sum + price;
      }, 0);
    },
    numg() {
      return this.input.equipment_expense.reduce((sum, item) => {
        const price = parseFloat(item.amount) || 0;
        return sum + price;
      }, 0);
    },
    numq() {
      return this.input.operating_expense.reduce((sum, item) => {
        const price = parseFloat(item.amount) || 0;
        return sum + price;
      }, 0);
    },
    numw() {
      return this.input.other_expense.reduce((sum, item) => {
        const price = parseFloat(item.amount) || 0;
        return sum + price;
      }, 0);
    },
    // fun(e) {
    // 	this.show = e;
    // 	if (e == 1) {
    // 		setTimeout(() => {
    // 			this.$refs.hdzsj.msg(this.id, this.name);
    // 		}, 40);
    // 	} else {
    // 		setTimeout(() => {
    // 			this.$refs.hdhsj.msg(this.id, this.name);
    // 		}, 40);
    // 	}
    // },
  }
};
</script>

<style scoped>
@media screen and (max-width: 991px) {
  .sjbzt {
    font-size: calc(14px + 0.4vw) !important;
  }
  .sjbxzt {
    font-size: calc(11px + 0.4vw) !important;
  }
  .show {
    display: block !important;
  }
  .none {
    display: none !important;
  }
}
.show{
	display: none;
}
.dcbd:hover {
  transform: scale(1.2);
}

.qieh {
  width: calc(100px + 0.4vw);
  text-align: center;
  border-radius: 12px 12px 0 0;
}
.card{
  background-color: #FFFFFF;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    /* margin-bottom: 20px; */
    overflow: hidden;
    border: 1px solid #E0E0E0;
}
.card-header{
  padding: 15px 20px;
  border-bottom: 1px solid #E0E0E0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #FFF6E0;
}
 /* 表格样式 */
 .data-table {
      width: 100%;
      border-collapse: collapse;
      margin: 20px 0;
      
  }
  .data-table thead{
      background: #FFF6E0;
      
  }

  .data-table th, .data-table td {
      padding: 12px 15px;
      text-align: left;
      border-bottom: 1px solid var(--border-color);
  }

  .data-table th {
      background-color: var(--primary-light);
      font-weight: 600;
      color: var(--text-color);
  }

  .data-table tr:nth-child(even) {
      background-color: rgba(0, 0, 0, 0.02);
  }

  .data-table tr:hover {
      background-color: rgba(0, 0, 0, 0.05);
  }
  .echarts-css-big{
    height: 400px;width: calc(26rem + 0.4vw);
  }
  .echarts-css-small{
    width: 100%;
    height: 400px;
  }
</style>